import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { parseHtml } from "@components/HTMLParser/utils";
import { useI18nStore } from "@store/i18n/i18nStore";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { useGetPlanRulesQuery } from "@services/planRules/queries";

interface IMaxPlanRulesFilesProps {
  jointBillServicePlanId: PlanId;
}

export const MaxPlanRulesFiles: React.FC<IMaxPlanRulesFilesProps> = (props) => {
  const { jointBillServicePlanId } = props;

  const { t } = useTranslation();

  const { locale } = useI18nStore();
  const { data } = useGetPlanRulesQuery(locale);

  const getRules = useCallback(
    (jointBillServicePlanId: PlanId) => {
      const rules = data?.find(
        (rules) =>
          rules.jointBillServicePlanId === jointBillServicePlanId.toString(),
      );

      return parseHtml(rules?.Files ?? "");
    },
    [data],
  );

  return (
    <div>
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MCI) &&
        getRules(PlanId.MCI)}
      {jointBillServicePlanId == PlanId.MAX && t("common.and")}
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MBI) &&
        getRules(PlanId.MBI)}
    </div>
  );
};
